// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";

// 🔥 API de autenticación
import {
  isAuthenticated as apiIsAuthenticated,
  getToken,
  getCurrentUser,
  clearAuth
} from "@/api/index.js";

// 🔥 Utilidades de permisos
import { hasPermission } from "@/utils/permissionUtils";
import { cargarPermisosDesdeAPI, limpiarCachePermisos } from "@/api/permisosService";
import MembresiasList from "@/views/MembresiasList.vue";
import TiposMembresiaList from "@/views/TiposMembresiaList.vue";
import AccesosList from "@/views/AccesosList.vue";
import ReportesGymView from "@/views/ReportesGymView.vue";
// =====================================================
// VIEWS - Auth
// =====================================================
import Login from "../views/layouts/auth/Login.vue";
import Register from "../views/layouts/auth/Register.vue";
import ForgotPassword from "../views/layouts/auth/forgot-password.vue";

// =====================================================
// VIEWS - Recarga de Gas
// =====================================================
import ZonasList from "@/views/gas/ZonasList.vue";
import TiposRecargaList from "@/views/gas/TiposRecargaList.vue";
import ClientesGasList from "@/views/gas/ClientesGasList.vue";
import PedidosRecargaList from "@/views/gas/PedidosRecargaList.vue";
import NuevoPedidoRecarga from "@/views/gas/NuevoPedidoRecarga.vue";
import DeliveryList from "@/views/gas/DeliveryList.vue";
import AsignacionesList from "@/views/gas/AsignacionesList.vue";
import PagosRecargaList from "@/views/gas/PagosRecargaList.vue";
import ReportesGas from "@/views/gas/ReportesGas.vue";
import ReportarPagoGas from "@/views/gas/publico/ReportarPagoGas.vue";
import ZonasMesaList from "@/views/Restaurante/ZonasMesaList.vue";
// Imports (arriba)
import MenusList from "@/views/Restaurante/MenusList.vue";
import MenuDetalle from "@/views/Restaurante/MenuDetalle.vue";
import ModificadoresList from "@/views/Restaurante/ModificadoresList.vue";
import ModificadorDetalle from "@/views/Restaurante/ModificadorDetalle.vue";
// =====================================================
// VIEWS - Landings públicas
// =====================================================
import TenantLanding from "@/views/TenantLanding.vue";
import TenantCatalogo from "@/views/TenantCatalogo.vue";
import CatalogoServicios from "../views/CatalogoServicios.vue";
import CatalogoProductos from "../views/CatalogoProductos.vue";

// =====================================================
// VIEWS - Principales
// =====================================================
import Dashboard from "../views/Dashboard.vue";
import UserProfile from "@/components/UserProfile.vue";
import WelcomeBanner from "@/components/WelcomeBanner.vue";
import SupportInfo from "@/components/SupportInfo.vue";

// =====================================================
// VIEWS - Módulos del sistema
// =====================================================
import ModulosList from "@/views/ModulosList.vue";
import PermisosList from "@/views/PermisosList.vue";
import RolesList from "@/views/RolesList.vue";
import UsuariosList from "@/views/UsuariosList.vue";
import TecnicosList from "@/views/TecnicosList.vue";
import VendedoresList from "@/views/VendedoresList.vue";
import EmpresaList from "@/views/EmpresaList.vue";
import SedesList from "@/views/SedesList.vue";
import AdminLicencia from "@/views/AdminLicencia.vue";
import CambiarContrasena from "@/views/CambiarContrasena.vue";
import MesasList from "@/views/Restaurante/MesasList.vue";
import AreasCocinaList from "@/views/Restaurante/AreasCocinaList.vue"; // 👈 NUEVO
// =====================================================
// VIEWS - Ventas
// =====================================================
import VentasList from "@/views/VentasList.vue";
import VentasCreate from "@/views/VentasCreate.vue";
import VentasCreateCredito from "@/views/VentasCreateCredito.vue";
import ClientesList from "@/views/ClientesList.vue";
import CotizacionesList from "@/views/CotizacionesList.vue";
import CotizacionCreate from "@/views/CotizacionCreate.vue";
import CotizacionDetail from "@/views/CotizacionDetail.vue";
import RegistroClienteGas from "@/views/gas/publico/RegistroClienteGas.vue";
import ConfirmacionRegistroGas from "@/views/gas/publico/ConfirmacionRegistroGas.vue";
import ExtragasHome from "@/views/gas/ExtragasWeb/ExtragasHome.vue";

// VIEWS - Servicios
// =====================================================
import ServiciosList from "@/views/ServiciosList.vue";
import RecepcionExpress from "@/views/RecepcionExpress.vue";
import RecepcionEquipoList from "@/views/RecepcionEquipoList.vue";
import SeguimientoOrden from "@/views/SeguimientoOrden.vue";
import ServicioExternoList from "@/views/ServicioExternoList.vue";
import InterServicios from "@/views/InterServicios.vue";
import EstadoRecepcionList from "@/views/EstadoRecepcionList.vue";
import PagoServicio from "@/views/PagoServicio.vue";

// =====================================================
// VIEWS - Inventario
// =====================================================
import CategoriasList from "@/views/CategoriasList.vue";
import ProductosList from "@/views/ProductosList.vue";
import ProductosRecepcion from "@/views/ProductosRecepcion.vue";
import ProductoServicioList from "@/views/ProductoServicioList.vue";

// =====================================================
// VIEWS - Herramientas
// =====================================================
import HerramientaTaller from "@/views/HerramientaTaller.vue";
import HerramientasList from "@/views/HerramientasList.vue";
import SalidaHerramientaList from "@/views/SalidaHerramientaList.vue";
import SalidaHerramientaCreate from "@/views/SalidaHerramientaCreate.vue";
import DevolucionHerramientaCreate from "@/views/DevolucionHerramientaCreate.vue";

// =====================================================
// VIEWS - Préstamos
// =====================================================
import PrestamosList from "@/views/PrestamosList.vue";
import PrestamoCreate from "@/views/PrestamoCreate.vue";
import PrestamoDetail from "@/views/PrestamoDetail.vue";

// =====================================================
// VIEWS - Finanzas
// =====================================================
import GastosList from "@/views/GastosList.vue";
import TasasCambioList from "@/views/TasasCambioList.vue";
import MetodosPagoView from "@/views/MetodosPagoView.vue";
import PagosList from "@/views/PagosList.vue";
import TiposCreditosList from "@/views/TiposCreditosList.vue";
import CuotasCreditoList from "@/views/CuotasCreditoList.vue";
import GestionCreditos from "@/views/GestionCreditos.vue";
import FacturaServiciosList from "@/views/FacturaServiciosList.vue";
import EstadoPagoList from "@/views/EstadoPagoList.vue";

// =====================================================
// VIEWS - Compras
// =====================================================
import ProveedoresList from "@/views/ProveedoresList.vue";
import CajasList from "@/views/CajasList.vue";

// =====================================================
// VIEWS - Reportes
// =====================================================
import ReporteProductos from "@/views/ReporteProductos.vue";
import ReporteVentas from "@/views/ReporteVentas.vue";
import ReporteGestion from "@/views/ReporteGestion.vue";
import ReporteProveedores from "@/views/ReporteProveedores.vue";
import ReporteRecepcionEquipo from "@/views/ReporteRecepcionEquipo.vue";
import ReporteTecnicoSemanal from "@/views/ReporteTecnicoSemanal.vue";
import DiagnosticoExpress from "@/views/DiagnosticoExpress.vue";

// =====================================================
// VIEWS - Huellas
// =====================================================
import GestionHuellas from "@/views/GestionHuellas.vue";
import AsistenciaList from "@/views/AsistenciaList.vue";

// =====================================================
// VIEWS - Notificaciones
// =====================================================
import NotificacionesList from "@/views/NotificacionesList.vue";
import GestionGasDashboard from "@/views/gas/GestionGasDashboard.vue";  // 👈 NUEVO
import EntrenadoresList from "@/views/EntrenadoresList.vue";

// =====================================================
// VIEWS - Errores
// =====================================================
import Blank from "../views/layouts/Blank.vue";
import Page404 from "../views/layouts/error/404.vue";
import Page500 from "../views/layouts/error/500.vue";
import PageMaintenance from "../views/layouts/error/maintenance.vue";
import SubscriptionExpired from "@/views/SubscriptionExpired.vue";

// =====================================================
// COMPONENTES DEMO
// =====================================================
import Tables from "../views/tables.vue";
import Valert from "../views/components/alert.vue";
import Vaccrodion from "../views/components/accordion.vue";
import Vbadges from "../views/components/badges.vue";
import Vbreadcumb from "../views/components/breadcumbs.vue";
import Vbutton from "../views/components/button.vue";
import Vcard from "../views/components/card.vue";
import Vdropdown from "../views/components/dropdown.vue";
import Vmodal from "../views/components/modal.vue";

const appname = " - SYSTEM JJ Sistema";

// =====================================================
// RUTAS
// =====================================================
const routes = [
  // ═══════════════════════════════════════════════════════
  // PÚBLICAS
  // ═══════════════════════════════════════════════════════
  { path: "/", redirect: "/login" },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "Iniciar Sesión" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { title: "Registro" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { title: "Recuperar Contraseña" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/Extragas-web",
    name: "ExtragasHome",
    component: ExtragasHome,
    meta: {
      title: "EXTRA GAS - Recarga de Gas a Domicilio",
      hideNav: true,
      publicPage: true
    }
  },

  // ═══════════════════════════════════════════════════════
  // GIMNASIO / MEMBRESÍAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/membresias",
    name: "MembresiasList",
    component: MembresiasList,
    meta: { title: "Membresías" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/tipos-membresia",
    name: "TiposMembresiaList",
    component: TiposMembresiaList,
    meta: { title: "Tipos de Membresía" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/accesos",
    name: "AccesosList",
    component: AccesosList,
    meta: { title: "Control de Acceso" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gym/reportes",
    alias: ["/gym-reportes", "/reportes-gym", "/gimnasio/reportes", "/gym/reporte-pagos", "/gym/reporte-accesos"],
    name: "ReportesGymView",
    component: ReportesGymView,
    meta: { title: "Reportes del Gimnasio" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },

  // Landings públicas
  {
    path: "/empresa/:tenantId",
    name: "TenantLanding",
    component: TenantLanding,
    props: true,
    meta: { title: "Landing" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/empresa/:tenantId/catalogo",
    name: "TenantCatalogo",
    component: TenantCatalogo,
    props: true,
    meta: { title: "Catálogo" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/catalogo-servicios",
    name: "CatalogoServicios",
    component: CatalogoServicios,
    meta: { title: "Catálogo de Servicios" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/catalogo-productos",
    name: "CatalogoProductos",
    component: CatalogoProductos,
    meta: { title: "Catálogo de Productos" + appname, hideNav: true, publicPage: true }
  },

  // Errores públicos
  {
    path: "/500",
    name: "Page500",
    component: Page500,
    meta: { title: "Error del Servidor" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: PageMaintenance,
    meta: { title: "Mantenimiento" + appname, hideNav: true, publicPage: true }
  },
  {
    path: "/bloqueado",
    name: "SubscriptionExpired",
    component: SubscriptionExpired,
    meta: { title: "Sistema Bloqueado" + appname, hideNav: true, publicPage: true }
  },

  // ═══════════════════════════════════════════════════════
  // PROTEGIDAS (con meta.permission)
  // ═══════════════════════════════════════════════════════

  // Bienvenida / Dashboard
  {
    path: "/bienvenida",
    name: "Bienvenida",
    component: () => import('@/views/BienvenidaPage.vue'),
    meta: { title: "Bienvenida" + appname, requiresAuth: true }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { title: "Dashboard" + appname, requiresAuth: true, permission: 'ver_dashboard' }
  },

  // Perfil
  {
    path: "/perfil",
    name: "Perfil",
    component: UserProfile,
    meta: { title: "Mi Perfil" + appname, requiresAuth: true }
  },
  {
    path: "/editar-perfil",
    name: "EditarPerfil",
    component: () => import('@/views/EditarPerfil.vue'),
    meta: { title: "Editar Perfil" + appname, requiresAuth: true }
  },
  {
    path: "/cambiar-contrasena",
    name: "CambiarContrasena",
    component: CambiarContrasena,
    meta: { title: "Cambiar Contraseña" + appname, requiresAuth: true }
  },
  {
    path: "/notificaciones",
    name: "NotificacionesList",
    component: NotificacionesList,
    meta: { title: "Notificaciones" + appname, requiresAuth: true }
  },
  {
    path: "/gas/reportar-pago",
    name: "ReportarPagoGas",
    component: ReportarPagoGas,
    meta: {
      title: "Reportar Pago - Recarga de Gas",
      hideNav: true,
      publicPage: true
    }
  },

    // ═══════════════════════════════════════════════════════
  // RESTAURANTE
  // ═══════════════════════════════════════════════════════
  {
    path: "/restaurante/zonas-mesa",
    name: "RestauranteZonasMesa",
    component: ZonasMesaList,
    meta: {
      title: "Zonas de Mesa - Restaurante" + appname,
      requiresAuth: true,
      permission: 'ver_ventas'   // ⚠️ Cambia por el permiso que uses para restaurante
    }
  },
{
  path: "/restaurante/mesas",
  name: "RestauranteMesas",
  component: MesasList,
  meta: {
    title: "Mesas - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'   // o el permiso que uses para restaurante
  }
},
{
  path: "/restaurante/modificadores",
  name: "ModificadoresList",
  component: ModificadoresList,
  meta: {
    title: "Modificadores - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/modificadores/:id",
  name: "ModificadorDetalle",
  component: ModificadorDetalle,
  meta: {
    title: "Detalle Modificador - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/areas-cocina",
  name: "RestauranteAreasCocina",
  component: AreasCocinaList,
  meta: {
    title: "Áreas de Cocina - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'   // o el permiso que uses para restaurante
  }
},
{
  path: "/restaurante/menus",
  name: "MenusList",
  component: MenusList,
  meta: {
    title: "Menús - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/menus/:id",
  name: "MenuDetalle",
  component: MenuDetalle,
  meta: {
    title: "Detalle del Menú - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/pedidos",
  name: "PedidosMesaList",
  component: () => import('@/views/Restaurante/PedidosMesaList.vue'),
  meta: {
    title: "Pedidos de Mesa - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/pedidos/:id",
  name: "PedidoMesaDetail",
  component: () => import('@/views/Restaurante/PedidoMesaDetail.vue'),
  meta: {
    title: "Detalle de Pedido - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},
{
  path: "/restaurante/plano-mesas",
  name: "MesasPlano",
  component: () => import('@/views/Restaurante/MesasPlano.vue'),
  meta: {
    title: "Plano de Mesas - Restaurante - SYSTEM JJ Sistema",
    requiresAuth: true,
    permission: 'ver_ventas'
  }
},

  // ═══════════════════════════════════════════════════════
  // GESTIÓN VENTAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/ventas",
    name: "VentasList",
    component: VentasList,
    meta: { title: "Ventas" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/ventas/nueva",
    name: "VentasCreate",
    component: VentasCreate,
    meta: { title: "Nueva Venta" + appname, requiresAuth: true, permission: 'realizar_venta' }
  },
  {
    path: "/ventas/nueva/credito",
    name: "VentasCreateCredito",
    component: VentasCreateCredito,
    meta: { title: "Venta a Crédito" + appname, requiresAuth: true, permission: 'realizar_venta_credito' }
  },

  // ═══════════════════════════════════════════════════════
  // VENTAS FISCALES (IMPRESORA FISCAL SENIAT)
  // ═══════════════════════════════════════════════════════
  {
    path: "/ventas/fiscales",
    alias: ["/ventas-fiscales"],
    name: "VentasFiscalesList",
    component: () => import('@/views/VentasFiscalesList.vue'),
    meta: { title: "Ventas Fiscales" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/ventas/fiscales/nueva",
    alias: ["/ventas-fiscales/nueva", "/ventas-fiscales/crear"],
    name: "VentasFiscalesCreate",
    component: () => import('@/views/VentasFiscalesCreate.vue'),
    meta: { title: "Nueva Venta Fiscal" + appname, requiresAuth: true, permission: 'realizar_venta' }
  },

  // ═══════════════════════════════════════════════════════
  // DEVOLUCIONES (VENTAS Y REPARACIONES / SERVICIOS)
  // ═══════════════════════════════════════════════════════
  {
    path: "/devoluciones",
    name: "DevolucionesList",
    component: () => import('@/views/DevolucionesList.vue'),
    meta: { title: "Devoluciones" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/devoluciones/nueva",
    alias: ["/devoluciones/crear"],
    name: "DevolucionCreate",
    component: () => import('@/views/DevolucionCreate.vue'),
    meta: { title: "Nueva Devolución" + appname, requiresAuth: true, permission: 'realizar_venta' }
  },
  {
    path: "/devoluciones/:id",
    name: "DevolucionDetail",
    component: () => import('@/views/DevolucionDetail.vue'),
    meta: { title: "Detalle de Devolución" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/clientes",
    name: "ClientesList",
    component: ClientesList,
    meta: { title: "Clientes" + appname, requiresAuth: true, permission: 'ver_clientes' }
  },
  {
    path: "/cotizaciones",
    name: "CotizacionesList",
    component: CotizacionesList,
    meta: { title: "Cotizaciones" + appname, requiresAuth: true, permission: 'ver_cotizaciones' }
  },
  {
    path: "/cotizaciones/nueva",
    name: "CotizacionCreate",
    component: CotizacionCreate,
    meta: { title: "Nueva Cotización" + appname, requiresAuth: true, permission: 'crear_cotizacion' }
  },
  {
    path: "/cotizaciones/:id",
    name: "CotizacionDetail",
    component: CotizacionDetail,
    meta: { title: "Detalle Cotización" + appname, requiresAuth: true, permission: 'ver_cotizaciones' }
  },

  // ═══════════════════════════════════════════════════════
  // GESTIÓN SERVICIOS
  // ═══════════════════════════════════════════════════════
  {
    path: "/servicios",
    name: "ServiciosList",
    component: ServiciosList,
    meta: { title: "Servicios" + appname, requiresAuth: true, permission: 'ver_servicios' }
  },
  {
    path: "/recepcion-express",
    name: "RecepcionExpress",
    component: RecepcionExpress,
    meta: { title: "Recepción y Reparación" + appname, requiresAuth: true, permission: 'acceso_nueva_orden' }
  },
  {
    path: "/recepcion-equipo-list",
    name: "RecepcionEquipoList",
    component: RecepcionEquipoList,
    meta: { title: "Reparación" + appname, requiresAuth: true, permission: 'ver_ordenes' }
  },
  {
    path: "/seguimiento/:id?",
    name: "SeguimientoOrden",
    component: SeguimientoOrden,
    meta: { title: "Seguimiento de Orden" + appname, requiresAuth: true, permission: 'ver_ordenes' }
  },
  {
    path: "/servicios-externos",
    name: "ServicioExternoList",
    component: ServicioExternoList,
    meta: { title: "Servicios Externos" + appname, requiresAuth: true, permission: 'ver_servicios' }
  },
  {
    path: "/inter-servicios",
    name: "InterServicios",
    component: InterServicios,
    meta: { title: "Servicios Inter" + appname, requiresAuth: true, permission: 'ver_inter' }
  },
  {
    path: "/estado-recepcion",
    name: "EstadoRecepcionList",
    component: EstadoRecepcionList,
    meta: { title: "Estado de Recepción" + appname, requiresAuth: true, permission: 'ver_estado_recepcion' }
  },
  {
    path: "/pago-servicio",
    name: "PagoServicio",
    component: PagoServicio,
    meta: { title: "Pago de Servicios" + appname, requiresAuth: true, permission: 'ver_servicios' }
  },

  // ═══════════════════════════════════════════════════════
  // GESTIÓN INVENTARIO
  // ═══════════════════════════════════════════════════════
  {
    path: "/categorias",
    name: "CategoriasList",
    component: CategoriasList,
    meta: { title: "Categorías" + appname, requiresAuth: true, permission: 'ver_categorias' }
  },
  {
    path: "/productos",
    name: "ProductosList",
    component: ProductosList,
    meta: { title: "Productos" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/productos-recepcion",
    name: "ProductosRecepcion",
    component: ProductosRecepcion,
    meta: { title: "Recepción de Productos" + appname, requiresAuth: true, permission: 'ver_recepcion_productos' }
  },
  {
    path: "/producto-servicio",
    name: "ProductoServicioList",
    component: ProductoServicioList,
    meta: { title: "Productos y Servicios" + appname, requiresAuth: true, permission: 'ver_producto_servicio' }
  },

  // ═══════════════════════════════════════════════════════
  // HERRAMIENTAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/herramienta-taller",
    name: "HerramientaTaller",
    component: HerramientaTaller,
    meta: { title: "Herramientas del Taller" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/kardex-herramienta",
    name: "KardexHerramientaList",
    component: HerramientasList,
    meta: { title: "Kardex HTA" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/salida-herramienta",
    name: "SalidaHerramientaList",
    component: SalidaHerramientaList,
    meta: { title: "Salidas de Herramientas" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/salida-herramienta/nueva",
    name: "SalidaHerramientaCreate",
    component: SalidaHerramientaCreate,
    meta: { title: "Nueva Salida HTA" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/devolucion-herramienta",
    name: "DevolucionHerramientaList",
    component: () => import('@/views/DevolucionHerramientaList.vue'),
    meta: { title: "Historial de Devoluciones" + appname, requiresAuth: true, permission: 'ver_productos' }
  },
  {
    path: "/devolucion-herramienta/nueva/:idSalida?",
    name: "DevolucionHerramientaCreate",
    component: DevolucionHerramientaCreate,
    meta: { title: "Devolución de Herramientas" + appname, requiresAuth: true, permission: 'ver_productos' }
  },

  // ═══════════════════════════════════════════════════════
  // PRÉSTAMOS
  // ═══════════════════════════════════════════════════════
  {
    path: "/prestamos",
    name: "PrestamosList",
    component: PrestamosList,
    meta: { title: "Préstamos" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/prestamos/nuevo",
    name: "PrestamoCreate",
    component: PrestamoCreate,
    meta: { title: "Nuevo Préstamo" + appname, requiresAuth: true, permission: 'realizar_venta' }
  },
  {
    path: "/prestamos/:id",
    name: "PrestamoDetail",
    component: PrestamoDetail,
    meta: { title: "Detalle Préstamo" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/prestamos/resumen",
    name: "PrestamoResumen",
    component: () => import('@/views/PrestamoResumen.vue'),
    meta: { title: "Resumen de Préstamos" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },

  // ═══════════════════════════════════════════════════════
  // FINANZAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/gastos",
    name: "GastosList",
    component: GastosList,
    meta: { title: "Gestión de Gastos" + appname, requiresAuth: true, permission: 'ver_gastos' }
  },
  {
    path: "/tasa-cambio",
    name: "TasasCambioList",
    component: TasasCambioList,
    meta: { title: "Tasa de Cambio" + appname, requiresAuth: true, permission: 'ver_tasa_cambio' }
  },
  {
    path: "/metodos-pago",
    name: "MetodosPagoView",
    component: MetodosPagoView,
    meta: { title: "Métodos de Pago" + appname, requiresAuth: true, permission: 'ver_metodos_pago' }
  },
  {
    path: "/pagos",
    name: "PagosList",
    component: PagosList,
    meta: { title: "Pagos" + appname, requiresAuth: true, permission: 'ver_pagos' }
  },
  {
    path: "/tipos-creditos",
    name: "TiposCreditosList",
    component: TiposCreditosList,
    meta: { title: "Tipos de Créditos" + appname, requiresAuth: true, permission: 'ver_tipos_creditos' }
  },
  {
    path: "/cuotas-credito",
    name: "CuotasCreditoList",
    component: CuotasCreditoList,
    meta: { title: "Cuotas de Crédito" + appname, requiresAuth: true, permission: 'ver_cuotas_credito' }
  },
  {
    path: "/gestion-creditos",
    name: "GestionCreditos",
    component: GestionCreditos,
    meta: { title: "Gestión de Créditos" + appname, requiresAuth: true, permission: 'ver_pagos' }
  },
  {
    path: "/factura-servicios",
    name: "FacturaServiciosList",
    component: FacturaServiciosList,
    meta: { title: "Factura de Servicios" + appname, requiresAuth: true, permission: 'ver_factura_servicios' }
  },
  {
    path: "/estado-pago",
    name: "EstadoPagoList",
    component: EstadoPagoList,
    meta: { title: "Estado de Pago" + appname, requiresAuth: true, permission: 'ver_estado_pago' }
  },

  // ═══════════════════════════════════════════════════════
  // RECARGA DE GAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/gas/zonas",
    name: "GasZonas",
    component: ZonasList,
    meta: { title: "Zonas de Cobertura" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gas/tipos-recarga",
    name: "GasTiposRecarga",
    component: TiposRecargaList,
    meta: { title: "Tipos de Recarga" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gas/clientes",
    name: "GasClientes",
    component: ClientesGasList,
    meta: { title: "Clientes de Gas" + appname, requiresAuth: true, permission: 'ver_clientes' }
  },
  {
    path: "/gas/pedidos",
    name: "GasPedidos",
    component: PedidosRecargaList,
    meta: { title: "Pedidos de Recarga" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gas/pedidos/nuevo",
    name: "GasNuevoPedido",
    component: NuevoPedidoRecarga,
    meta: { title: "Nuevo Pedido" + appname, requiresAuth: true, permission: 'realizar_venta' }
  },
  {
    path: "/gas/delivery",
    name: "GasDelivery",
    component: DeliveryList,
    meta: { title: "Delivery / Repartidores" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gas/asignaciones",
    name: "GasAsignaciones",
    component: AsignacionesList,
    meta: { title: "Asignaciones de Delivery" + appname, requiresAuth: true, permission: 'ver_ventas' }
  },
  {
    path: "/gas/pagos",
    name: "GasPagos",
    component: PagosRecargaList,
    meta: { title: "Pagos de Recarga" + appname, requiresAuth: true, permission: 'ver_pagos' }
  },
  {
    path: "/gas/reportes",
    name: "GasReportes",
    component: ReportesGas,
    meta: { title: "Reportes de Gas" + appname, requiresAuth: true, permission: 'ver_gestion_reportes' }
  },

  // ═══════════════════════════════════════════════════════
  // PÚBLICAS - REGISTRO DE GAS (SIN AUTH)
  // ═══════════════════════════════════════════════════════
  {
    path: "/gas/registro",
    name: "RegistroClienteGas",
    component: RegistroClienteGas,
    meta: {
      title: "Registro de Cliente - Recarga de Gas",
      hideNav: true,
      publicPage: true
    }
  },
  {
    path: "/gas/registro/confirmacion",
    name: "ConfirmacionRegistroGas",
    component: ConfirmacionRegistroGas,
    meta: {
      title: "¡Registro Exitoso!",
      hideNav: true,
      publicPage: true
    }
  },

  // ═══════════════════════════════════════════════════════
  // COMPRAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/proveedores",
    name: "ProveedoresList",
    component: ProveedoresList,
    meta: { title: "Proveedores" + appname, requiresAuth: true, permission: 'ver_proveedores' }
  },
  {
    path: "/ordenes-compra",
    name: "ComprasList",
    component: () => import('@/views/ComprasList.vue'),
    meta: { title: "Órdenes de Compra" + appname, requiresAuth: true, permission: 'ver_compras' }
  },
  {
    path: "/compras/nueva",
    name: "ComprasCreate",
    component: () => import('@/views/ComprasCreate.vue'),
    meta: { title: "Nueva Compra" + appname, requiresAuth: true, permission: 'crear_compras' }
  },
  {
    path: "/cajas",
    name: "CajasList",
    component: CajasList,
    meta: { title: "Cajas" + appname, requiresAuth: true, permission: 'ver_cajas' }
  },

  // ═══════════════════════════════════════════════════════
  // REPORTES
  // ═══════════════════════════════════════════════════════
  {
    path: "/gestion-reportes",
    name: "ReporteGestion",
    component: ReporteGestion,
    meta: { title: "Panel de Gestión" + appname, requiresAuth: true, permission: 'ver_gestion_reportes' }
  },
  {
    path: "/reporte-productos",
    name: "ReporteProductos",
    component: ReporteProductos,
    meta: { title: "Reporte de Productos" + appname, requiresAuth: true, permission: 'ver_reporte_productos' }
  },
  {
    path: "/reporte-ventas",
    name: "ReporteVentas",
    component: ReporteVentas,
    meta: { title: "Reporte de Ventas" + appname, requiresAuth: true, permission: 'ver_reporte_ventas' }
  },
  {
    path: "/reporte-proveedores",
    name: "ReporteProveedores",
    component: ReporteProveedores,
    meta: { title: "Reporte de Proveedores" + appname, requiresAuth: true, permission: 'ver_reporte_proveedores' }
  },
  {
    path: "/reporte-recepcion-equipo",
    name: "ReporteRecepcionEquipo",
    component: ReporteRecepcionEquipo,
    meta: { title: "Reporte de Recepción" + appname, requiresAuth: true, permission: 'ver_reporte_ordenes' }
  },
  {
    path: "/configuracion_credito",
    name: "ConfiguracionCredito",
    component: () => import('@/views/ConfiguracionCredito.vue'),
    meta: { title: "Configuración de Crédito" + appname, requiresAuth: true, permission: 'ver_configuracion_credito' }
  },
  {
    path: "/retenciones",
    name: "RetencionesList",
    component: () => import('@/views/RetencionesList.vue'),
    meta: { title: "Retenciones" + appname, requiresAuth: true, permission: 'ver_retenciones' }
  },
  {
    path: "/reporte-tecnico-semanal",
    name: "ReporteTecnicoSemanal",
    component: ReporteTecnicoSemanal,
    meta: { title: "Reporte Técnico Semanal" + appname, requiresAuth: true, permission: 'ver_reporte_ordenes' }
  },

  // ═══════════════════════════════════════════════════════
  // HUELLAS
  // ═══════════════════════════════════════════════════════
  {
    path: "/gestion-huellas",
    name: "GestionHuellas",
    component: GestionHuellas,
    meta: { title: "Gestión de Huellas" + appname, requiresAuth: true, permission: 'ver_usuarios' }
  },
  {
    path: "/asistencia",
    name: "AsistenciaList",
    component: AsistenciaList,
    meta: { title: "Control de Asistencia" + appname, requiresAuth: true, permission: 'ver_usuarios' }
  },

  // ═══════════════════════════════════════════════════════
  // DIAGNÓSTICOS EXPRESS
  // ═══════════════════════════════════════════════════════
  {
    path: "/diagnostico-express",
    name: "DiagnosticoExpress",
    component: DiagnosticoExpress,
    meta: { title: "Diagnósticos EXPRESS" + appname, requiresAuth: true, permission: 'ver_reporte_ordenes' }
  },
  {
    path: "/diagnostico-express/todos",
    name: "DiagnosticoExpressTodos",
    component: DiagnosticoExpress,
    meta: { title: "Todos los EXPRESS" + appname, requiresAuth: true, permission: 'ver_reporte_ordenes' }
  },

  // ═══════════════════════════════════════════════════════
  // SEGURIDAD
  // ═══════════════════════════════════════════════════════
  {
    path: "/usuarios",
    name: "UsuariosList",
    component: UsuariosList,
    meta: { title: "Usuarios" + appname, requiresAuth: true, permission: 'ver_usuarios' }
  },
  {
    path: "/roles",
    name: "RolesList",
    component: RolesList,
    meta: { title: "Roles" + appname, requiresAuth: true, permission: 'ver_roles' }
  },
  {
    path: "/tecnicos",
    name: "TecnicosList",
    component: TecnicosList,
    meta: { title: "Técnicos" + appname, requiresAuth: true, permission: 'ver_usuarios' }
  },
  {
    path: "/vendedores",
    name: "VendedoresList",
    component: VendedoresList,
    meta: { title: "Vendedores" + appname, requiresAuth: true, permission: 'ver_usuarios' }
  },
  {
    path: "/modulos",
    name: "ModulosList",
    component: ModulosList,
    meta: { title: "Módulos del Sistema" + appname, requiresAuth: true, permission: 'ver_modulos' }
  },
  {
    path: "/permisos",
    name: "PermisosList",
    component: PermisosList,
    meta: { title: "Permisos del Sistema" + appname, requiresAuth: true, permission: 'ver_permisos' }
  },

  // ═══════════════════════════════════════════════════════
  // ENTRENADORES
  // ═══════════════════════════════════════════════════════
  {
    path: "/entrenadores",
    name: "EntrenadoresList",
    component: EntrenadoresList,
    meta: {
      title: "Entrenadores" + appname,
      requiresAuth: true,
      permission: 'ver_usuarios'
    }
  },
  {
    path: "/sedes",
    name: "SedesList",
    component: SedesList,
    meta: { title: "Administrar Sedes" + appname, requiresAuth: true, permission: 'ver_sedes' }
  },
  {
    path: "/control-licencias",
    name: "ControlLicencias",
    component: () => import('@/views/ControlLicenciasView.vue'),
    meta: { title: "Control de Licencias y Mantenimientos" + appname, requiresAuth: true }
  },
  {
    path: "/empresa",
    name: "EmpresaList",
    component: EmpresaList,
    meta: { title: "Gestión de Empresas" + appname, requiresAuth: true, permission: 'ver_empresa' }
  },
  {
    path: "/admin-licencia",
    name: "AdminLicencia",
    component: AdminLicencia,
    meta: { title: "Administrar Licencia" + appname, requiresAuth: true, permission: 'ver_admin_licencia' }
  },
  {
    path: "/configuracion",
    name: "Configuracion",
    component: Blank,
    meta: { title: "Configuración" + appname, requiresAuth: true, permission: 'configurar_sistema' }
  },
  {
    path: "/gas/panel-gestion",
    name: "GasPanelGestion",
    component: GestionGasDashboard,
    meta: { title: "Panel de Gestión - Gas" + appname, requiresAuth: true, permission: 'ver_gestion_reportes' }
  },
  {
    path: "/soporte-tecnico",
    name: "soporte-tecnico",
    component: SupportInfo,
    meta: { title: "Soporte Técnico" + appname, requiresAuth: true, permission: 'ver_soporte' }
  },
  {
    path: "/gym-dashboard",
    name: "GymDashboard",
    component: () => import('@/views/GymDashboard.vue'),
    meta: {
      title: "Panel del Gimnasio" + appname,
      requiresAuth: true,
      permission: 'ver_ventas'
    }
  },

  // ═══════════════════════════════════════════════════════
  // COMPONENTES DEMO (no críticos)
  // ═══════════════════════════════════════════════════════
  { path: "/component/alert", name: "Valert", component: Valert, meta: { title: "Alert" + appname, requiresAuth: true } },
  { path: "/component/accordion", name: "Vaccordion", component: Vaccrodion, meta: { title: "Accordion" + appname, requiresAuth: true } },
  { path: "/component/badge", name: "Vbadge", component: Vbadges, meta: { title: "Badge" + appname, requiresAuth: true } },
  { path: "/component/breadcumb", name: "Vbreadcumb", component: Vbreadcumb, meta: { title: "Breadcumb" + appname, requiresAuth: true } },
  { path: "/component/button", name: "Vbutton", component: Vbutton, meta: { title: "Button" + appname, requiresAuth: true } },
  { path: "/component/card", name: "Vcard", component: Vcard, meta: { title: "Card" + appname, requiresAuth: true } },
  { path: "/component/dropdown", name: "Vdropdown", component: Vdropdown, meta: { title: "Dropdown" + appname, requiresAuth: true } },
  { path: "/component/modal", name: "Vmodal", component: Vmodal, meta: { title: "Modal" + appname, requiresAuth: true } },
  { path: "/Blank", name: "BlankPage", component: Blank, meta: { title: "Blank Page" + appname, requiresAuth: true } },
  { path: "/tables", name: "Tables", component: Tables, meta: { title: "Tables" + appname, requiresAuth: true } },

  // ═══════════════════════════════════════════════════════
  // 404 SIEMPRE AL FINAL
  // ═══════════════════════════════════════════════════════
  {
    path: "/:pathMatch(.*)*",
    name: "Page404",
    component: Page404,
    meta: { title: "404" + appname, hideNav: true, publicPage: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: "exact-active"
});

// =====================================================
// AUTENTICACIÓN
// =====================================================
const checkAuthentication = () => {
  const authStatus = apiIsAuthenticated();
  if (!authStatus) {
    const token = getToken();
    const user = getCurrentUser();
    if (token && user) {
      localStorage.setItem('isAuthenticated', 'true');
      return true;
    }
    return false;
  }
  return authStatus;
};

// ⏱️ Helper para esperar a que el login termine de guardar
const esperarAutenticacion = async (maxMs = 2000) => {
  const start = Date.now();
  while (Date.now() - start < maxMs) {
    if (checkAuthentication()) return true;
    await new Promise(r => setTimeout(r, 100));
  }
  return checkAuthentication();
};

// =====================================================
// GUARD PRINCIPAL
// =====================================================
router.beforeEach(async (to, from, next) => {
  // Título de la página
  document.title = to.meta.title || 'SYSTEM JJ Sistema';

  // 1. Páginas públicas → permitir siempre
  const isPublicPage = to.matched.some(record => record.meta.publicPage);
  if (isPublicPage) {
    // Si ya está autenticado y va a /login → redirigir al panel
    if (to.path === '/login' && checkAuthentication()) {
      return next('/bienvenida');
    }
    next();
    return;
  }

  // 2. Verificar autenticación
  // ⚠️ Si venimos del login, esperar a que setAuth termine
  let isAuth = checkAuthentication();

  if (!isAuth && (from.path === '/login' || from.path === '/' || from.name === 'Login')) {
    console.log('⏳ Esperando a que el login termine de guardar...');
    isAuth = await esperarAutenticacion(2000);
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !isAuth) {
    console.log('🔒 Ruta protegida sin auth, redirigiendo a login');
    next('/login');
    return;
  }

  // 3. Si está autenticado y va a login → redirigir a bienvenida
  if (isAuth && (to.path === '/login' || to.path === '/')) {
    next('/bienvenida');
    return;
  }

  // 4. Verificar permiso (si la ruta lo requiere)
  if (isAuth) {
    const requiredPermission = to.meta.permission;

    // Rutas sin permiso declarado → permitir
    if (!requiredPermission) {
      next();
      return;
    }

    try {
      const granted = await hasPermission(requiredPermission);

      if (granted) {
        next();
      } else {
        console.warn(`⛔ Acceso denegado a "${to.path}" - requiere: "${requiredPermission}"`);
        showAccessDenied();

        // Redirigir a una ruta segura
        if (to.path !== '/bienvenida' && to.path !== '/gestion-reportes') {
          next('/bienvenida');
        } else {
          next(false);
        }
      }
    } catch (error) {
      console.error('❌ Error verificando permiso:', error);
      next('/bienvenida');
    }
  } else {
    next();
  }
});

// =====================================================
// HELPERS
// =====================================================
const showAccessDenied = () => {
  if (typeof window === 'undefined') return;
  if (window.Swal) {
    window.Swal.fire({
      icon: 'error',
      title: 'Acceso Denegado',
      text: 'No tienes permisos para acceder a esta sección.',
      timer: 3000
    });
  } else {
    window.dispatchEvent(new CustomEvent('access-denied', {
      detail: { message: 'Acceso denegado. No tienes permisos.' }
    }));
  }
};

// =====================================================
// HELPERS EXPORTADOS
// =====================================================
export const canAccessRoute = async (routeName) => {
  const route = router.resolve({ name: routeName });
  if (!route) return false;
  const requiredPermission = route.meta?.permission;
  if (!requiredPermission) return true;
  return await hasPermission(requiredPermission);
};

export const getAllowedRoutes = async () => {
  const allowed = [];
  for (const route of router.options.routes) {
    if (route.meta?.publicPage || route.meta?.hideNav) continue;
    if (!route.meta?.requiresAuth) continue;

    const perm = route.meta.permission;
    if (!perm || await hasPermission(perm)) {
      allowed.push({
        path: route.path,
        name: route.name,
        title: route.meta?.title?.replace(appname, '') || route.name
      });
    }
  }
  return allowed;
};

export const logoutUser = () => {
  clearAuth();
  import('@/api/permisosService').then(({ limpiarCachePermisos }) => {
    limpiarCachePermisos();
  });
  window.dispatchEvent(new CustomEvent('userLoggedOut'));
  router.push('/login');
};

export const reloadPermissions = async () => {
  limpiarCachePermisos();
  const user = getCurrentUser();
  if (user?.idRol) {
    await cargarPermisosDesdeAPI(user.idRol);
  }
};

// =====================================================
// LISTENER DE STORAGE (solo si OTRAS pestañas cambian)
// =====================================================
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    // ⚠️ Este evento SOLO se dispara en otras pestañas, no en la actual
    if (['user', 'token', 'isAuthenticated'].includes(event.key)) {
      const isAuth = checkAuthentication();
      // Si se cerró sesión en otra pestaña → redirigir
      if (!isAuth && router.currentRoute.value.meta.requiresAuth) {
        console.log('🔒 Sesión cerrada en otra pestaña, redirigiendo...');
        router.push('/login');
      }
    }
  });
}

export default router;